import type { FC } from 'react';
import type { ModalProps } from 'react-native';
import { Modal, StyleSheet, View } from 'react-native';
import { PaperProvider } from 'react-native-paper';

import { WEB_MAX_WIDTH } from '@/constants/web';
import { PopupProvider } from '@/features/popup/provider/PopupProvider';
import { isWeb } from '@/shared/utils/platform';
import { useGetAppTheme } from '@/styles/hooks/useGetAppTheme';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    // Isolate the modal content into its own stacking context. Without this,
    // the absolute-positioned labels of Paper TextInputs inside the modal
    // (zIndex: 3) escape their subtree and paint above bottom sheets that are
    // portaled from within the same Modal on the new architecture (iOS).
    isolation: 'isolate',
    // RN Modal portals out of the centered app container on web, so the
    // max-width constraint must be re-applied here — once, for all modals.
    ...(isWeb && {
      width: '100%',
      maxWidth: WEB_MAX_WIDTH,
      marginHorizontal: 'auto'
    })
  }
});

export const ExtendedModal: FC<ModalProps> = ({ children, ...props }) => {
  const theme = useGetAppTheme();

  return (
    <Modal {...props}>
      <PaperProvider theme={theme}>
        <PopupProvider>
          <View style={styles.container}>{children}</View>
        </PopupProvider>
      </PaperProvider>
    </Modal>
  );
};
